export default angular.module('eventix.common.services.LibraryLoader', [])
    /**
     * @ngdoc object
     * @name eventix.common.services.LibraryLoaderProvider
     * @description
     * Load an external script dynamically
     */
    /**
     * @ngdoc object
     * @name eventix.common.services.LibraryLoader
     * @description
     * Load an external script dynamically
     */
    .provider('LibraryLoader', function() {
        /**
         * @ngdoc method
         * @name eventix.common.services.LibraryLoaderProvider#load
         * @methodOf eventix.common.services.LibraryLoaderProvider
         * @description
         * Load an external script dynamically
         *
         * @param {String} url The URL of the external script
         * @param {Object} options Object with `{ cors: Boolean, timeout: Number }`
         * @param {Function} cb Callback function with one optional error argument
         */
        this.load = load;
        function load(url, options = {}, cb = angular.noop) {
            if(!url || !url.length) {
                cb(new Error('Invalid url: ' + url));
                return;
            }
            let timeout;
            let counter = 0;
            const script = document.createElement('script');
            options = _.defaults(options, {
                timeout: 5000
            });
            script.async = true;
            script.defer = true;
            if(options.cors)
                script.setAttribute('crossorigin', 'anonymous');
            if(options.id)
                script.id = options.id;
            script.src = url;
            script.onload = function() {
                clearInterval(timeout);
                cb();
            };
            script.onerror = function(error) {
                clearInterval(timeout);
                cb(error);
            };
            document.getElementsByTagName('body')[0].appendChild(script);
            timeout = setInterval(function() {
                counter++;
                if(counter * 500 < options.timeout)
                    return;
                clearInterval(timeout);
                cb(new Error('Timeout loading: ' + url));
            }, 500);
        }

        this.$get = function($window, $interval, $q) {
            return {
                /**
                * @ngdoc method
                * @name eventix.common.services.LibraryLoader#load
                * @methodOf eventix.common.services.LibraryLoader
                * @description
                * Load an external script dynamically
                *
                * @param {String} url The URL of the external script
                * @param {Object} options Object with `{ cors: Boolean, timeout: Number }`
                * @return {Promise<Any>} Resolves with empty or rejects with an Error
                */
                load: function(url, options) {
                    return $q(function(resolve, reject) {
                        load(url, options, error => error ? reject(error) : resolve());
                    });
                }
            };
        };
    }).name;
